export default __webpack_public_path__ + "static/media/niifi-logo-light.c787f794.png";